<template>
  <div id="noteList">
    <v-form ref="noteListForm">
      <v-container class="pa-0">
        <v-layout>
            <v-flex class="xs12 sm12 mb-5">
                <v-btn v-if="editMode && !session.getSession().adminUser" fab absolute class="ml-3 pf-btn-fab" @click="backToList()">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-btn v-if="!editMode && !session.getSession().adminUser" fab absolute left :to="{ path: '/admin/families'}" class="ml-3 pf-btn-fab">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-btn fab absolute right v-if="!editMode && session.getSession().adminUser" :to="{ path: '/admin/addNotes'}" class="ml-3 pf-btn-fab">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
        <v-container fluid v-if="editMode">
            <v-layout row wrap>
              <v-flex xs12 sm6>
              <v-select v-model="editableNoteObj.issue"
                outline
                label="Issue"
                :items="IssueList"
                class="pl-3 pr-3"
                @change="isFormDataChanged = true">
              </v-select>
              </v-flex>
              <v-flex xs12>
              <v-text-field outline v-model.trim="editableNoteObj.title" label="Add a title" class="pl-3 pr-3 required" :rules="[rules.required]" @input="isFormDataChanged = true"></v-text-field>
              <v-textarea outline v-model="editableNoteObj.note" rows="10" label="Add Notes" class="pl-3 pr-3" @input="isFormDataChanged = true"></v-textarea>
                <upload-btn multiple @file-update="fileSelected($event)" noTitleUpdate :title="title">
                  <template slot="icon">
                      <v-icon right dark>cloud_upload</v-icon>
                  </template>
                  <template slot="text-field"></template>
                </upload-btn>
                <v-layout v-if="editableNoteObj.files.length" xs12 xs6 class="d-block mr-4 ml-4 mt-2">
                  <p pa-0><label>Seleted files</label></p>
                  <template v-for="(file, i) in editableNoteObj.files">
                    <span :key="i">
                      <v-chip
                        close
                        @input="removeNoteFile(file)"
                      >
                        <span>{{ file.name }}</span>
                      </v-chip>
                    </span>
                  </template>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="button-container pr-4 pl-4">
            <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
              <div class="d-inline-flex">
                <v-btn class="pf-btn pf-btn-cancel" @click="backToList">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="updateNote">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
        </v-layout>
        </v-container>
        <v-container fluid v-if="!editMode">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card-title class="pb-0">
                  <b>Notes</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-select
                  v-model="search"
                  append-icon="search"
                  label="Search by Recent time"
                  :items="selectList"
                  @change="sortByDate"
                  outline
                  single-line
                ></v-select>
              </v-card-title>
              <v-card class="mt-3">
                <v-data-table
                  :headers="headers"
                  :items="notesList"
                  class="pf-data-table"
                  ref="sortableTable"
                  :pagination.sync="pagination"
                  no-data-text="There is no notes"
                >
                  <template v-slot:items="props">
                    <tr>
                      <td width="150px">{{ formatDateMethod(props.item.createdAt, 'MM/DD/YYYY hh:mm') }}</td>
                      <td align="center" width="150px">{{ props.item.createdBy ? props.item.createdBy.human.name : '--' }}</td>
                      <td align="center" width="200px">{{ props.item.title ? props.item.title : '--' }}</td>
                      <td align="center">{{ props.item.note ? props.item.note : '--' }}</td>
                      <td width="150px" v-if="props.item.files.length === 0">No files found</td>
                      <td width="150px" v-else>
                        <div v-for="(file, index) in props.item.files" :key="file._id">
                          <span>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on" class="pointer">file {{ index + 1 }}</span>
                              </template>
                            <span>{{ file.name }}</span>
                        </v-tooltip>
                            <v-btn icon class="ma-0" v-if="file.mimetype.lastIndexOf('image/') !== -1" @click="viewImage(`${config.uploadPath}${file.webPath}`)">
                              <v-icon small color="grey darken-2">remove_red_eye</v-icon>
                            </v-btn>
                            <v-btn icon class="ma-0" @click="downloadImage(`${config.uploadPath}${file.webPath}`)">
                              <v-icon small color="grey darken-2">save_alt</v-icon>
                            </v-btn>
                          </span>
                        </div>
                      </td>
                      <td align="right" width="100px">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-btn icon class="ma-0" @click="editNotes(props.item)" small>
                              <v-icon size="22" color="grey darken-2">edit</v-icon>
                            </v-btn>
                          </span>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-btn icon class="ma-0" @click="deleteNotes(props.item)" small>
                              <v-icon size="22" color="grey darken-2" >delete_outline</v-icon>
                            </v-btn>
                          </span>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row justify-center>
        <v-dialog v-model="dialog" class="text-xs-center" max-width="400">
            <v-layout wrap>
              <v-card>
                <v-card-actions class="text-xs-right">
                <v-spacer></v-spacer>
                  <v-icon @click="dialog=!dialog" size="32" color="#f195bf" class="pr-1">cancel</v-icon>
              </v-card-actions>
                <img
                  class="image_class_dialog"
                  :src="DialogImg"
                  height="100%"
                  width="100%"
                />
              </v-card>
            </v-layout>
          </v-dialog>
        </v-layout>
        </v-container>
    </v-form>
  </div>
</template>
<script>

/* global session store moment config */
import Vue from 'vue';
import swal from 'sweetalert2';
import { getCollection, uploadFile, remove, update, formatDate } from '../../helpers/helpers';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import UploadButton from 'vuetify-upload-button';
import { saveAs } from 'file-saver';
import { mapGetters } from 'vuex';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
export default {
  name: 'FamilyNotes',
  components: {
    'upload-btn': UploadButton,
  }, 
  data: vm => ({
    config: config,
    title: 'Select file(s)',
    dialog: false,
    DialogImg: '',
    editMode: false,
    headers: [
      { text: 'Date / Time', sortable: false },
      { text: 'Person', sortable: false, align: 'center' },
      { text: 'Title', sortable: false, align: 'center' },
      { text: 'Note', sortable: false, align: 'center' },
      { text: 'Files', sortable: false, align: 'left' },
      { text: 'Actions', width: '100px', sortable: false, align: 'right' },
    ],
    rules: {
      required: value => !!value || 'Title is required.',
    },
    IssueList: [
      'Yes',
      'No',
    ],
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: 10,
    },
    notesList: [],
    selectList: ['Recent First', 'Recent Last'],
    search: 'Recent First',
    accountDataId: '',
    isFormDataChanged: false,
    editableIndex: -1,
    editableNoteObj: {}
  }),
  computed: {
    ...mapGetters(['Account']),
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    if (!session.getSession().adminUser) {
      this.accountDataId = this.$route.params.item ? this.$route.params.item.id : undefined;
      if (!this.accountDataId) {
        this.$router.push({ path: '/admin/families' });
      } else {
        await this.getNotes();
      }
    } else {
      this.accountDataId = this.Account.id;
      this.getNotes();
    }
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    async fileSelected (files) {
      if (this.$refs.noteListForm.validate()) {
        this.newFileUpload(files);
      }
    },
    async newFileUpload (selectedfiles) {
      let noteFiles = [];
      this.selectedData = false;
      let errorHtml = null;
      let files = selectedfiles;
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          if (files[i] !== 'undefined') {
            this.fileName = files[i].name;
            if (this.fileName.lastIndexOf('.') <= 0) {
              return;
            }
            if (files[i].size > this.config.uploadFileSize) {
              errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
            }
            if (errorHtml) {
              swal.fire({
                title: `<strong>Upload Error</strong>`,
                type: 'error',
                html: errorHtml,
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText: 'Close',
              });
              return;
            }
            window.getApp.$emit('AppProgress', true);
            const fr = new FileReader();
            fr.readAsDataURL(files[i]);
            fr.addEventListener('load', async () => {
              noteFiles.push(files[i]);
              if (i + 1 === files.length) {
                this.addNoteApiCall(noteFiles);
              }
            });
          } 
        }
      }
    },
    async addNoteApiCall (noteFiles) {
      let postUrl = `Note/${this.editableNoteObj.id}/Upload`;
      let response = await uploadFile(postUrl, noteFiles, 'PUT');
      if (!response.$data) {
        window.getApp.$emit('AppProgress', false);
        console.log('error', response.$error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: response.$error
        };
      } else {
        swal.fire({
          type: 'success',
          title: 'File(s) uploaded successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.notesList[this.editableIndex] = response.$data;
            this.editableNoteObj = response.$data;
            this.title = this.editableNoteObj.files.length > 0 ? `${this.editableNoteObj.files.length} selected` : 'Select file(s)';
          }
        });
      }
    },
    async getNotes () {
      let where = { account: this.accountDataId };
      let { error, data } = await getCollection('Note', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.notesList = data;
        }
      }
    },
    async updateNote () {
      if (this.$refs.noteListForm.validate()) {
        let editableNotePayload = {
          title: this.editableNoteObj.title,
          note: this.editableNoteObj.note,
          account: this.accountDataId,
          files: this.editableNoteObj.files,
          issue: this.editableNoteObj.issue
        };
        let { error, data, status } = await update('Note', editableNotePayload, this.editableNoteObj.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          swal.fire({
            type: 'success',
            title: 'Notes updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.notesList[this.editableIndex] = data;
              this.editableNoteObj = data;
              this.backToList();
            }
          });
        }
      }
    },
    async removeNoteFile (item) {
      if (this.$refs.noteListForm.validate()) {
        const index = this.editableNoteObj.files.indexOf(item);
        if (index >= 0) this.editableNoteObj.files.splice(index, 1);
        this.title = this.editableNoteObj.length > 0 ? `${this.editableNoteObj.length} selected` : 'Select file(s)';
        let editableNotePayload = {
          title: this.editableNoteObj.title,
          note: this.editableNoteObj.note,
          account: this.accountDataId,
          files: this.editableNoteObj.files,
          issue: this.editableNoteObj.issue
        };
        let { error, data, status } = await update('Note', editableNotePayload, this.editableNoteObj.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          swal.fire({
            type: 'success',
            title: 'Notes updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.notesList[this.editableIndex] = data;
              this.editableNoteObj = data;
            }
          });
        }
      }
    },
    viewImage (imgUrl) {
      this.dialog = true;
      this.DialogImg = imgUrl;
    },
    async downloadImage (urlPath) {
      let filename = urlPath.substring(urlPath.lastIndexOf('/') + 1);
      saveAs(urlPath, filename);
    },
    async downloadFile (cdnPath) {
      let filename = cdnPath.substring(cdnPath.lastIndexOf('/') + 1);
      saveAs(cdnPath, filename);
    },
    deleteNotes (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Note', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.notesList.indexOf(item);
              this.notesList.splice(index, 1);
              swal.fire(
                'Deleted!',
                `"${item.title}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    async editNotes (item) {
      this.editMode = true;
      this.editableIndex = this.notesList.findIndex(note => note._id === item._id);
      this.editableNoteObj = JSON.parse(JSON.stringify(this.notesList[this.editableIndex]));
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.title = this.editableNoteObj.files.length > 0 ? `${this.editableNoteObj.files.length} selected` : 'Select file(s)';
    },
    async addNotesCancel () {
      window.getApp.$emit('pageSubHeader', '');
      this.editMode = false;
      this.editableNoteObj = {};
      this.editableIndex = -1;
    },
    sortByDate () {
      this.pagination.descending = !this.pagination.descending;
    },
    backToList () {
      window.getApp.$emit('pageSubHeader', '');
      this.editMode = false;
      this.editableNoteObj = {};
      this.editableIndex = -1;
    },
  }
};
</script>

<style lang="css" scoped>

  .pointer {
    cursor: pointer;
  }
  #noteList >>> .v-icon.material-icons.accent--text {
    color: #019d8c !important;
    caret-color:  #019d8c !important;
  }

  #noteList >>> .v-input__slot {
    flex-direction: row-reverse;
  }

  #noteList >>> .v-label.theme--light {
    width: 300px;
  }

  #noteList >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}

#noteList >>> .v-select .v-text-field__details {
  display: none !important;
}

 .messageSubject {
   display: block;
   font-size: 15px;
 }

 .messageNames{
   color: rgba(0,0,0,0.87);
 }
 .messageNames, .messageContent {
  font-size: 16px;
  font-weight: 800;
 }

 .image_class {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80px;
}

.pdf_class {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image_class_dialog {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 250px;
}

</style>


// WEBPACK FOOTER //
// src/pages/Notes/list.vue